module.exports = __webpack_public_path__ + "static/media/25UNHCR2.1b5e5013.jpg";